module.exports = {
	"pagination": {
		"DescribeCacheClusters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheClusters"
		},
		"DescribeCacheEngineVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheEngineVersions"
		},
		"DescribeCacheParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheParameterGroups"
		},
		"DescribeCacheParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeCacheSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheSecurityGroups"
		},
		"DescribeCacheSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheSubnetGroups"
		},
		"DescribeEngineDefaultParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "EngineDefaults.Marker",
			"result_key": "EngineDefaults.Parameters"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeReplicationGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReplicationGroups"
		},
		"DescribeReservedCacheNodes": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedCacheNodes"
		},
		"DescribeReservedCacheNodesOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedCacheNodesOfferings"
		},
		"DescribeSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Snapshots"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticache-2015-02-02.paginators.json
// module id = 605
// module chunks = 0